import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@React_UI_Lib/Button";
import Tooltip from "@React_UI_Lib/ReactToolTip";
import DateAndTimeMmt from "../HobTimeWidgetMmt/HobTimeWidgetMmt";
import { useToast } from "../../Toast";
import * as S from "./HouseOfBrandsMmtStyles";
import {
  HOB_CAR_IMG_URL,
  HOB_CHAT_ICON_URL,
  HOB_DOWN_ARROW_URL,
  HOB_FROM_IMG_URL,
  HOB_FROM_IMG_URL_DISABLED,
  HOB_MMT_LOGO_URL,
  HOB_TO_IMG_URL,
  HOB_TO_IMG_URL_DISABLED,
  MAKE_MY_TRIP,
  PROVISIONAL_HOB_REQUEST_TYPE,
  errActionCta,
  errIcon,
  smallCabLogos,
  HOB_EDIT_FILL_ICON,
} from "../../../../../config/constants";
import { getProvisionalDataHOBMmt } from "../../../redux/thunks";
import SrcDestPickerMmt from "../SrcDestPickerMmt/SrcDestPickerMmt";
import {
  hobDestinationLocationSelector,
  hobFlightIdSelector,
  hobIsDepartureSelector,
  hobLandingResponseSelector,
  hobPickupTimeSelector,
  hobSourceLocationSelector,
  hobSourceSelector,
  useSourceLocationSelector,
} from "../../../redux/selector";
import {
  UPDATE_HOB_LANDING_RESPONSE,
  UPDATE_HOB_PICKUP_TIME,
  UPDATE_USE_SOURCE_LOCATION,
} from "../../../redux/action-types";
import { getRandomNumber, formatTime, formatDate } from "../../../utils";
import useNavigate from "../../../../../hooks/useNavigate";
import {
  CALENDAR_BACK_CLICKED,
  CALENDAR_DONE_CLICKED,
  CHECK_FARE_CLICK,
  EDIT_CLICKED,
  EDIT_SOURCE_CLICKED,
  HOB_DESTINATION_NOT_ENETERED,
  HOB_SOURCE_DESTINATION_SAME,
  HOB_SOURCE_NOT_ENETERED,
} from "../../../../../utils/util-constants";
import {
  PROVISIONAL_HOB_OVERLAY_PAGE_LANDING,
  trackEvent,
  trackPageView,
} from "../../../../../config/omniMmt";
import ErrorMmtScreen from "../ErrorMmtScreen/ErrorMmtScreen";
import { DateTimePicker } from "@gommt-cabs/ui-lib";

const HouseOfBrandsMmt = (props) => {
  const showToast = useToast();
  const dispatch = useDispatch();
  const [navigateTo] = useNavigate();

  const [inputValue, setInputValue] = useState("Enter drop location ");
  const [sourceInput, setSourceInput] = useState("Enter pick up location ");
  const [cabPosition, setCabPosition] = useState("");
  const [errScreenData, setErrScreenData] = useState(null);
  const [provResponse, setProvisionalResponse] = useState(null);
  const [showDateTimeWidget, setShowDateTimeWidget] = useState(false);
  const [showDestPickerWidget, setShowDestPickerWidget] = useState(false);
  const [showSrcPickerWidget, setShowSrcPickerWidget] = useState(false);
  const [minimumPickupDate, setMinimumPickupDate] = useState(new Date());
  const [randomNumber, setRandomNumber] = useState(getRandomNumber());

  const flightId = useSelector(hobFlightIdSelector);
  const source = useSelector(hobSourceSelector);
  const isDeparture = useSelector(hobIsDepartureSelector);
  const provisionalResponse = useSelector(hobLandingResponseSelector);
  const time = useSelector(hobPickupTimeSelector);
  const destinationLocation = useSelector(hobDestinationLocationSelector);
  const sourceLocation = useSelector(hobSourceLocationSelector);
  const useSourceLocation = useSelector(useSourceLocationSelector);

  useEffect(() => {
    async function fetchAndSetProvisonalData(request) {
      const response = await getProvisionalDataHOBMmt(request);
      const provisionalResponse = response?.response?.[0] || null;
      setProvisionalResponse(provisionalResponse);
      if (provisionalResponse) {
        dispatch({
          type: UPDATE_HOB_LANDING_RESPONSE,
          data: {
            provisionalResponse: provisionalResponse,
            source_message: provisionalResponse?.source_message,
            airport_city_code: provisionalResponse?.airport_city_code,
            terminal: provisionalResponse?.terminal,
            pickupTime: provisionalResponse?.default_pickup_time,
          },
        });
      }
      validateAndTrackeProvisionalResponse(response);
    }
    let animationFrameId;
    let lastUpdate = Date.now();

    const animate = () => {
      const now = Date.now();
      if (now - lastUpdate >= 5000) {
        // 5000 ms = 5 seconds
        setCabPosition((prevCabPosition) =>
          prevCabPosition === "newCabPosition" ? "" : "newCabPosition"
        );
        const newRandomNumber = getRandomNumber();
        setRandomNumber(newRandomNumber);
        lastUpdate = now;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    try {
      let request = {
        flight_id: flightId,
        source_param: source,
        is_departure: isDeparture,
        type: PROVISIONAL_HOB_REQUEST_TYPE,
      };
      if (Boolean(provisionalResponse)) {
        const eventDetails = {
          eVar3: provisionalResponse?.airport_name,
          eVar13: provisionalResponse?.airport_name,
          eVar71: source,
        };
        trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, eventDetails);
        setProvisionalResponse(provisionalResponse);
      } else {
        fetchAndSetProvisonalData(request);
      }
    } catch (e) {
      //
    }

    animate();

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  useEffect(() => {
    if (destinationLocation?.address) {
      setInputValue(destinationLocation?.address);
    }

    if (sourceLocation?.address) {
      setSourceInput(sourceLocation?.address);
    }
  }, [destinationLocation, sourceLocation]);

  useEffect(() => {
    if (provisionalResponse?.default_pickup_time) {
      setMinimumPickupDate(new Date(provisionalResponse?.default_pickup_time));
      setTime(time || provResponse?.default_pickup_time);
    }
  }, [provisionalResponse?.default_pickup_time]);

  const formatTextWithBold = (text) => {
    const boldRegex = /\*([^*]+)\*/g;
    return text.split(boldRegex).map((part, index) => {
      if (index % 2 === 0) {
        return part;
      } else {
        return <strong key={index}>{part}</strong>;
      }
    });
  };

  const setTime = (time) => {
    dispatch({
      type: UPDATE_HOB_PICKUP_TIME,
      pickupTime: time,
    });
  };

  /**
   * Validates a provisional response and performs tracking based on the response data.
   * @param {object} provisionalResponse - The provisional response object containing response and error details.
   * @param {Array} provisionalResponse.response - Array containing response data.
   * @param {string} provisionalResponse.errors.error_list - List of errors in the response.
   * @returns {void}
   */
  const validateAndTrackeProvisionalResponse = (provisionalResponse) => {
    if (Boolean(provisionalResponse?.response?.length)) {
      const eventDetails = {
        eVar3: provisionalResponse?.response?.[0]?.airport_name,
        eVar13: provisionalResponse?.response?.[0]?.airport_name,
        eVar71: source,
      };
      trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, eventDetails);
    } else {
      const eventDetails = {
        eVar22: provisionalResponse?.errors?.error_list[0]?.code,
      };
      trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, eventDetails);
      setErrScreenData(provisionalResponse?.errors?.error_list[0]);
    }
  };

  const handleDestinationEmpty = () => {
    trackEvent(
      PROVISIONAL_HOB_OVERLAY_PAGE_LANDING,
      HOB_DESTINATION_NOT_ENETERED
    );
    showToast("Please enter your Destination", "Lato");
  };

  const handleSourceEmpty = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, HOB_SOURCE_NOT_ENETERED);
    showToast("Please enter your Source", "Lato");
  };

  const handleSourceDestinationSame = () => {
    trackEvent(
      PROVISIONAL_HOB_OVERLAY_PAGE_LANDING,
      HOB_SOURCE_DESTINATION_SAME
    );
    showToast("Please enter different source and destination", "Lato");
  };

  /**
   * Handles the click event for checking fare, triggering relevant tracking events and dispatchs,
   * @async
   * @function checkFareClicked
   * @returns {void}
   */
  const checkFareClicked = async () => {
    const eventDetails = {
      eVar13: `${provResponse?.airport_city_code}_${provResponse?.terminal}|${
        destinationLocation?.city || destinationLocation?.address || ""
      }`,
    };
    trackEvent(
      PROVISIONAL_HOB_OVERLAY_PAGE_LANDING,
      CHECK_FARE_CLICK,
      eventDetails
    );
    if (!flightId && !sourceLocation?.address) {
      handleSourceEmpty();
      return;
    }

    if (!destinationLocation?.address) {
      handleDestinationEmpty();
      return;
    }

    if (
      !flightId &&
      sourceLocation?.place_id === destinationLocation?.place_id
    ) {
      handleSourceDestinationSame();
      return;
    }

    navigateTo("listingHob");
  };

  const onBackPressed = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, CALENDAR_BACK_CLICKED);
    setShowDateTimeWidget(false);
  };

  const onDonePressed = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, CALENDAR_DONE_CLICKED);
    setShowDateTimeWidget(false);
  };

  const onEditClicked = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, EDIT_CLICKED);
    setTime(time || provResponse?.default_pickup_time);
    setShowDateTimeWidget(true);
  };

  const onEditSourceClick = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, EDIT_SOURCE_CLICKED);
    dispatch({
      type: UPDATE_USE_SOURCE_LOCATION,
      useSourceLocation: true,
      sourceLocation: provResponse?.source_location,
    });
  };

  if (provResponse && !Object.keys(provResponse)?.length) {
    return null;
  }

  if (errScreenData) {
    return (
      <ErrorMmtScreen
        title={errScreenData?.title}
        message={errScreenData?.message || errScreenData?.code}
        icon={errIcon}
        cta={errActionCta}
      />
    );
  }

  return (
    <>
      {provResponse && Object.keys(provResponse)?.length ? (
        <S.BrandLpContainer>
          <S.BrandLpBgTop
            style={{
              backgroundImage: `url(${provResponse?.image})`,
            }}
          >
            <S.TerminalMarker>
              <S.PulsatingCircle>
                <S.InnerCircle>
                  <S.InnerPlus />
                </S.InnerCircle>
              </S.PulsatingCircle>
              {provResponse?.terminal ? (
                <Tooltip
                  text={provResponse?.terminal}
                  showTooltipAlways={provResponse?.terminal ? true : false}
                />
              ) : null}
            </S.TerminalMarker>
            <S.TerminalCabsContainer className={`${cabPosition || ""}`}>
              <Tooltip text={`${randomNumber} min`} showTooltipAlways={true} />
              <div className="cab-images">
                <S.TerminalCarImg className="cab1" src={HOB_CAR_IMG_URL} />
                <S.TerminalCarImg className="cab2" src={HOB_CAR_IMG_URL} />
                <S.TerminalCarImg className="cab3" src={HOB_CAR_IMG_URL} />
              </div>
            </S.TerminalCabsContainer>

            <S.BrandLpHeader>
              <S.MmtLogo src={HOB_MMT_LOGO_URL} />
              <S.BrandMMTHeaderTitle>{MAKE_MY_TRIP}</S.BrandMMTHeaderTitle>
            </S.BrandLpHeader>
          </S.BrandLpBgTop>
          <S.BottomFixedSection>
            <S.BrandLpBgBottom>
              <S.GetCabTitle>{provResponse?.title}</S.GetCabTitle>
              <S.GetBrandSubTitle>
                {provResponse?.description}
              </S.GetBrandSubTitle>
              <S.PartnerCabLogos>
                {smallCabLogos.map((img, i) => (
                  <S.SmallCabLogos src={img} key={"smallCabLogos" + i} />
                ))}
              </S.PartnerCabLogos>
            </S.BrandLpBgBottom>
            <S.SchedulingSection>
              <S.SchedulingSectionContainer>
                {provResponse?.airport_name && !useSourceLocation ? (
                  <>
                    <S.PickLabel>Pick up from:</S.PickLabel>
                    <S.PickupEditContainer>
                      <S.PickUpLocation>
                        {provResponse?.airport_name}
                      </S.PickUpLocation>
                      {provisionalResponse?.open_from_search ? (
                        <S.EditIcon
                          src={HOB_EDIT_FILL_ICON}
                          onClick={onEditSourceClick}
                        />
                      ) : null}
                    </S.PickupEditContainer>
                  </>
                ) : (
                  <S.InputLocationCont
                    showDisabled={!sourceLocation?.address}
                    onClick={() => {
                      setShowSrcPickerWidget(true);
                    }}
                  >
                    <img
                      src={
                        !sourceLocation?.address
                          ? HOB_FROM_IMG_URL_DISABLED
                          : HOB_FROM_IMG_URL
                      }
                    />
                    <div className="titleSubtitleCont">
                      <div className="title">FROM</div>
                      <div className="subtitle">{sourceInput}</div>
                    </div>
                  </S.InputLocationCont>
                )}
                <S.InputLocationCont
                  showDisabled={!destinationLocation?.address}
                  onClick={() => {
                    setShowDestPickerWidget(true);
                  }}
                >
                  <img
                    src={
                      !destinationLocation?.address
                        ? HOB_TO_IMG_URL_DISABLED
                        : HOB_TO_IMG_URL
                    }
                  />
                  <div className="titleSubtitleCont">
                    <div className="title">TO</div>
                    <div className="subtitle">{inputValue}</div>
                  </div>
                </S.InputLocationCont>
                <S.DateTimeWrapper>
                  <S.DateTimeSection>
                    <div className="date-time-container">
                      <S.DtLabel>Date & Time</S.DtLabel>
                      <S.DateNTime>
                        <S.RideTime>
                          {formatDate(
                            time ||
                              `${provisionalResponse?.default_pickup_time}`,
                            true
                          )}
                        </S.RideTime>
                        <S.Seperator>|</S.Seperator>
                        <S.RideTime>
                          {formatTime(
                            time ||
                              `${provisionalResponse?.default_pickup_time}`
                          )}
                        </S.RideTime>
                      </S.DateNTime>
                    </div>
                    <S.EditTimeContainer onClick={() => onEditClicked()}>
                      Edit Time{" "}
                      <img
                        className="down-arrow-date"
                        src={HOB_DOWN_ARROW_URL}
                      />
                    </S.EditTimeContainer>
                  </S.DateTimeSection>
                  {provResponse?.flight_info_text && (
                    <S.FlightTxtMsgContainer>
                      <img src={HOB_CHAT_ICON_URL} className="chatIc" />
                      <p>
                        {formatTextWithBold(provResponse?.flight_info_text)}
                      </p>
                    </S.FlightTxtMsgContainer>
                  )}
                </S.DateTimeWrapper>
              </S.SchedulingSectionContainer>
              <div>
                <S.BottomBrandBtn>
                  <Button
                    handleClick={() => checkFareClicked()}
                    customClass={`primaryCustBtn`}
                    variant="primary"
                    content={`${provResponse?.check_fare_section?.btn_text}`}
                  />
                </S.BottomBrandBtn>
              </div>
            </S.SchedulingSection>
          </S.BottomFixedSection>
          {showDateTimeWidget && (
            <S.BottomSheetBackdrop
              isOpen={showDateTimeWidget}
              onClick={onBackPressed}
            >
              <S.BottomSheet
                isOpen={showDateTimeWidget}
                onClick={(e) => e.stopPropagation()}
              >
                <DateTimePicker
                  minStartDate={minimumPickupDate}
                  onBackClick={onBackPressed}
                  startDate={
                    new Date(time || provResponse?.default_pickup_time)
                  }
                  onFooterBtnClick={({ startDate }) => {
                    setTime(startDate.getTime());
                    onDonePressed();
                  }}
                />{" "}
              </S.BottomSheet>
            </S.BottomSheetBackdrop>
          )}
          {showDestPickerWidget || showSrcPickerWidget ? (
            <S.WidgetPopUp>
              <SrcDestPickerMmt
                isPickup={showSrcPickerWidget}
                locationName={
                  showSrcPickerWidget
                    ? sourceLocation?.address
                    : destinationLocation?.address
                }
                onBackClick={() => {
                  setShowSrcPickerWidget(false);
                  setShowDestPickerWidget(false);
                }}
              />
            </S.WidgetPopUp>
          ) : null}
        </S.BrandLpContainer>
      ) : null}
    </>
  );
};

export default HouseOfBrandsMmt;
